import { CapoPlugin } from "/Users/haoli/Documents/code/guoxin/ai_web/ai_pc/node_modules/.pnpm/@unhead+vue@1.10.0_vue@3.4.38/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];